import { Link } from "react-router-dom";
import SEO from "../components/SEO"; // Add this import
import "./legal.css";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Add SEO component with noindex settings */}
      <SEO
        title="Privacy Policy - Anjali Daswani Music"
        description="Privacy Policy for Anjali Daswani's official music website. Learn how we collect, use, and protect your information."
        url="https://anjalidmusic.com/privacy"
        keywords="privacy policy, Anjali Daswani, data protection, website privacy"
        // robots="noindex, follow" // Don't index legal pages but allow following links
      />

      <div className="legal-page">
        {/* Hero Section */}
        <section className="legal-hero-section">
          <div className="container">
            <div className="legal-hero-content">
              <h1 className="legal-title">Privacy Policy</h1>
              <p className="legal-subtitle">
                Last updated:{" "}
                {new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="legal-content-section">
          <div className="container">
            <div className="legal-content">
              <div className="legal-intro">
                <p>
                  This Privacy Policy describes how Anjali Daswani ("the
                  Artist") collects, uses, and protects your information when
                  you visit this website and use the services provided.
                </p>
              </div>

              <div className="legal-section">
                <h2>Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>Access the personal information held about you</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your personal information</li>
                  <li>Unsubscribe from email communications at any time</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Information Collected</h2>

                <h3>Information You Provide</h3>
                <p>
                  When you subscribe to music updates or contact Anjali Daswani
                  through the website, the following information may be
                  collected:
                </p>
                <ul>
                  <li>Email address (for music updates and responses)</li>
                  <li>Name (optional, for personalized communication)</li>
                  <li>Messages and inquiries sent through the contact form</li>
                </ul>

                <h3>Automatically Collected Information</h3>
                <p>
                  Certain information may be collected automatically when you
                  visit this website:
                </p>
                <ul>
                  <li>Usage data and analytics (through Google Analytics)</li>
                  <li>Device and browser information</li>
                  <li>IP address and location data</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>How Information Is Used</h2>
                <p>The collected information is used to:</p>
                <ul>
                  <li>
                    Send updates about new music releases and performances
                  </li>
                  <li>Respond to inquiries and messages</li>
                  <li>Improve the website and user experience</li>
                  <li>Analyze website usage and trends</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Information Sharing</h2>
                <p>
                  Personal information is not sold, traded, or otherwise
                  transferred to third parties without consent, except:
                </p>
                <ul>
                  <li>When required by law or legal process</li>
                  <li>To protect rights, property, or safety</li>
                  <li>
                    With trusted service providers who assist in website
                    operations (like Firebase for data storage)
                  </li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Data Security</h2>
                <p>
                  Appropriate security measures are implemented to protect
                  personal information. However, no method of transmission over
                  the internet is 100% secure, and absolute security cannot be
                  guaranteed.
                </p>
              </div>

              <div className="legal-section">
                <h2>Third-Party Services</h2>
                <p>
                  This website may contain links to third-party services
                  including:
                </p>
                <ul>
                  <li>
                    Music streaming platforms (Spotify, Apple Music, Amazon
                    Music)
                  </li>
                  <li>
                    Social media platforms (Instagram, TikTok, Facebook,
                    LinkedIn)
                  </li>
                  <li>Video platforms (YouTube)</li>
                </ul>
                <p>
                  These services have their own privacy policies. Users are
                  encouraged to review their policies when visiting their
                  websites.
                </p>
              </div>

              <div className="legal-section">
                <h2>Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>Access the personal information I have about you</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your personal information</li>
                  <li>Unsubscribe from email communications at any time</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Children's Privacy</h2>
                <p>
                  This website is not intended for children under 13. Personal
                  information from children under 13 is not knowingly collected.
                  If you are a parent and believe your child has provided
                  personal information, please contact Anjali Daswani through
                  the website.
                </p>
              </div>

              <div className="legal-section">
                <h2>Changes to This Policy</h2>
                <p>
                  This Privacy Policy may be updated from time to time. Any
                  changes will be posted on this page with an updated "Last
                  Modified" date.
                </p>
              </div>

              <div className="legal-section">
                <h2>Contact Information</h2>
                <p>
                  If you have questions about this Privacy Policy, please
                  contact Anjali Daswani through the{" "}
                  <Link to="/contact" className="legal-link">
                    contact form
                  </Link>{" "}
                  on this website.
                </p>
              </div>

              <div className="legal-navigation">
                <Link to="/terms" className="btn-secondary">
                  View Terms of Service
                </Link>
                <Link to="/" className="btn-primary">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
